"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 *
 * Converts instance of {@class ReportDto} to {@class ExportReportDto}
 * Created by Hayk.Andriasyan on 7/10/2017.
 */
var ExportReportDtoConverter = /** @class */ (function () {
    function ExportReportDtoConverter() {
    }
    ExportReportDtoConverter.convertToExportReportDto = function (reportDto) {
        return ExportReportDtoConverter.buildExportedReport(reportDto.rowRootDto, reportDto.columnRootDto);
    };
    ExportReportDtoConverter.buildExportedReport = function (rowRootDto, columnRootDto) {
        var exportReportBuilder = new idm_report_export_service_client_js_1.ExportReportDtoBuilder();
        for (var i = 0; i < rowRootDto.children.length; ++i) {
            var rowCategoryDto = rowRootDto.children[i];
            var exportRowCategoryBuilder = ExportReportDtoConverter.addRowCategoryFields(rowCategoryDto, exportReportBuilder);
            ExportReportDtoConverter.buildExportReportForRowCategory(rowRootDto.children[i], exportRowCategoryBuilder);
        }
        for (var i = 0; i < columnRootDto.children.length; ++i) {
            if (columnRootDto.children[i] instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var category = columnRootDto.children[i];
                var exportColumnBuilder = exportReportBuilder.addColumnCategory(category.categoryElementDto.categoryPathHolderId);
                ExportReportDtoConverter.addColumnCategoryFields(category, exportColumnBuilder);
                ExportReportDtoConverter.buildExportReportForColumnCategory(columnRootDto.children[i], exportColumnBuilder);
            }
            else {
                var measure = columnRootDto.children[i];
                var exportColumnBuilder = exportReportBuilder.addColumnMeasure(measure.measurePathHolderId);
                ExportReportDtoConverter.addColumnMeasureFields(measure, exportColumnBuilder);
                ExportReportDtoConverter.buildExportReportForColumnMeasure(measure, exportColumnBuilder);
            }
        }
        return exportReportBuilder.build();
    };
    ExportReportDtoConverter.buildExportReportForRowCategory = function (rowItem, builder) {
        if (rowItem.children && rowItem.children.length > 0) {
            var children = rowItem.children;
            for (var i = 0; i < children.length; ++i) {
                var rowCategoryDto = children[i];
                var exportRowCategoryBuilder = ExportReportDtoConverter.addRowCategoryFields(rowCategoryDto, builder);
                ExportReportDtoConverter.buildExportReportForRowCategory(children[i], exportRowCategoryBuilder);
            }
        }
    };
    ExportReportDtoConverter.buildExportReportForColumnCategory = function (columnItem, builder) {
        if (columnItem.children && columnItem.children.length > 0) {
            var children = columnItem.children;
            for (var i = 0; i < children.length; ++i) {
                if (columnItem.children[i] instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                    var category = columnItem.children[i];
                    var exportColumnBuilder = builder.addColumnCategory(category.categoryElementDto.categoryPathHolderId);
                    ExportReportDtoConverter.addColumnCategoryFields(category, exportColumnBuilder);
                    ExportReportDtoConverter.buildExportReportForColumnCategory(columnItem.children[i], exportColumnBuilder);
                }
                else {
                    var measure = columnItem.children[i];
                    var exportColumnBuilder = builder.addColumnMeasure(measure.measurePathHolderId);
                    ExportReportDtoConverter.addColumnMeasureFields(measure, exportColumnBuilder);
                    ExportReportDtoConverter.buildExportReportForColumnMeasure(measure, exportColumnBuilder);
                }
            }
        }
    };
    ExportReportDtoConverter.buildExportReportForColumnMeasure = function (columnItem, exportColumnMeasureBuilder) {
        if (columnItem.children && columnItem.children.length > 0) {
            var children = columnItem.children;
            for (var i = 0; i < children.length; ++i) {
                var category = columnItem.children[i];
                var exportColumnCategoryBuilder = exportColumnMeasureBuilder.addColumnCategory(category.categoryElementDto.categoryPathHolderId);
                ExportReportDtoConverter.addColumnCategoryFields(category, exportColumnCategoryBuilder);
                ExportReportDtoConverter.buildExportReportColumnCategoryAfterMeasure(category, exportColumnCategoryBuilder);
            }
        }
    };
    ExportReportDtoConverter.buildExportReportColumnCategoryAfterMeasure = function (columnItem, exportColumnCategoryBuilder) {
        if (columnItem.children && columnItem.children.length > 0) {
            var children = columnItem.children;
            for (var i = 0; i < children.length; ++i) {
                var category = columnItem.children[i];
                var childBuilder = exportColumnCategoryBuilder.addColumnCategory(category.categoryElementDto.categoryPathHolderId);
                ExportReportDtoConverter.addColumnCategoryFields(category, exportColumnCategoryBuilder);
                ExportReportDtoConverter.buildExportReportColumnCategoryAfterMeasure(category, childBuilder);
            }
        }
    };
    ExportReportDtoConverter.addColumnCategoryFields = function (columnCategoryDto, columnCategoryBuilder) {
        columnCategoryBuilder = columnCategoryBuilder.setOrderType(columnCategoryDto.orderType)
            .setOtherType(columnCategoryDto.categoryElementDto.otherType)
            .setTotalType(columnCategoryDto.categoryElementDto.totalType)
            .setShowAsType(columnCategoryDto.categoryElementDto.showAsType)
            .setShowOnRowsTotal(columnCategoryDto.showOnRowsTotal);
        if (columnCategoryDto.filterTreeDto) {
            columnCategoryBuilder.setFilter(columnCategoryDto.filterTreeDto);
        }
        if (columnCategoryDto.categoryElementDto.topCount) {
            columnCategoryBuilder.setTopCount(columnCategoryDto.categoryElementDto.topCount);
        }
    };
    ExportReportDtoConverter.addColumnMeasureFields = function (columnMeasureDto, columnMeasureBuilder) {
        columnMeasureBuilder = columnMeasureBuilder
            .setOrderType(columnMeasureDto.orderType)
            .setShowInPercentage(columnMeasureDto.isShowInPercentage)
            .setShowOnRowsTotal(columnMeasureDto.showOnRowsTotal);
        if (columnMeasureDto.currencyId) {
            columnMeasureBuilder.setCurrencyId(columnMeasureDto.currencyId);
        }
        if (columnMeasureDto.filterTreeDto) {
            columnMeasureBuilder.setFilter(columnMeasureDto.filterTreeDto);
        }
    };
    ExportReportDtoConverter.addRowCategoryFields = function (rowCategoryDto, exportReportDtoBuilder) {
        var rowCategoryBuilder = exportReportDtoBuilder.addRowCategory(rowCategoryDto.categoryElementDto.categoryPathHolderId);
        rowCategoryBuilder.setOrderType(rowCategoryDto.orderType)
            .setOtherType(rowCategoryDto.categoryElementDto.otherType)
            .setTotalType(rowCategoryDto.categoryElementDto.totalType)
            .setShowAsType(rowCategoryDto.categoryElementDto.showAsType);
        if (rowCategoryDto.filterTreeDto) {
            rowCategoryBuilder.setFilter(rowCategoryDto.filterTreeDto);
        }
        if (rowCategoryDto.categoryElementDto.topCount) {
            rowCategoryBuilder.setTopCount(rowCategoryDto.categoryElementDto.topCount);
        }
        return rowCategoryBuilder;
    };
    return ExportReportDtoConverter;
}());
exports.ExportReportDtoConverter = ExportReportDtoConverter;
//# sourceMappingURL=export-report-dto-converter.js.map